import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_any_of_the_following_measures_in_place_regard'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_any_of_the_following_measures_in_place_regard',
  name: 'Does the facility have any of the following measures in place regarding on-site childcare facilities?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'CHILDCARE_FACILITIES_ARE_ON_THE_GROUND_FLOOR',
      text: 'Childcare facilities are on the ground floor',
      externalIds: [
        {
          id: 'hs-57--3-2x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CHILDCARE_FACILITIES_ARE_KEPT_CLEAN_SAFE_AND_HYGIENIC_INCLUDING',
      text: 'Childcare facilities are kept clean, safe, and hygienic (including temperature, ventilation, light, noise etc.)',
      externalIds: [
        {
          id: 'hs-57--3-3x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CHILDCARE_FACILITIES_ARE_PROVIDED_WITH_ADEQUATE_SUPPLIES_AND_IN',
      text: 'Childcare facilities are provided with adequate supplies and infrastructure (i.e. food, recreational items, washroom, feeding area etc.)',
      externalIds: [
        {
          id: 'hs-57--3-4x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CHILDCARE_STAFF_GO_THROUGH_AN_APPROPRIATE_PRE_WORK_SCREENING_PR',
      text: 'Childcare staff go through an appropriate pre-work screening process',
      externalIds: [
        {
          id: 'hs-57--3-5x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CHILDCARE_STAFF_ARE_PRESENT_IN_SUFFICIENT_NUMBERS_TO_ENSURE_THE',
      text: 'Childcare staff are present in sufficient numbers to ensure the safety and well-being of the number of children present',
      externalIds: [
        {
          id: 'hs-57--3-6x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CAPACITY_OF_THE_CHILDCARE_FACILITY_IS_SUFFICIENT_TO_COVER_THE_N',
      text: 'Capacity of the childcare facility is sufficient to cover the need of all workers',
      externalIds: [
        {
          id: 'hs-chi-2x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'A_SYSTEM_IS_IN_PLACE_TO_ENSURE_THAT_CHILDREN_ARE_ONLY_RELEASED_',
      text: 'A system is in place to ensure that children are only released to parents or other authorized adult/guardians',
      externalIds: [
        {
          id: 'hs-57--3-7x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'hs-57--3-8x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'CHILDCARE_FACILITIES_ARE_ON_THE_GROUND_FLOOR',
                'CHILDCARE_FACILITIES_ARE_KEPT_CLEAN_SAFE_AND_HYGIENIC_INCLUDING',
                'CHILDCARE_FACILITIES_ARE_PROVIDED_WITH_ADEQUATE_SUPPLIES_AND_IN',
                'CHILDCARE_STAFF_GO_THROUGH_AN_APPROPRIATE_PRE_WORK_SCREENING_PR',
                'CHILDCARE_STAFF_ARE_PRESENT_IN_SUFFICIENT_NUMBERS_TO_ENSURE_THE',
                'CAPACITY_OF_THE_CHILDCARE_FACILITY_IS_SUFFICIENT_TO_COVER_THE_N',
                'A_SYSTEM_IS_IN_PLACE_TO_ENSURE_THAT_CHILDREN_ARE_ONLY_RELEASED_',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-chi-1',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 17570,
  sectionId: '2.2.2.1',
  impactArea: 'Child Care',
  impactAreaId: 'CHILD_CARE',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
